export default __webpack_public_path__ + "static/media/HDTX_KI Perubahan_Tambahan PKU 2025.bc176700.pdf";